__turbopack_context__.v({
  "badge": "ImpersonationBadge-module-scss-module__JONvBa__badge",
});
